import logo from './logo.svg';
import './App.css';
import '@aws-amplify/ui-react/styles.css';
import { Input, Label, Flex } from '@aws-amplify/ui-react'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          This domain name is for sale.
          <Flex direction="column" gap="small">
            <Label htmlFor="small">Your email</Label>
            <Input id="large" size="large" width="100%" type="email"/>
          </Flex>
        </p>

      </header>
    </div>
  );
}

export default App;
